import { Component, Input } from '@angular/core';

import { AppConstants } from '../../../app.constants';
import { ILauncherFeature } from '../../../core/interfaces/launcher-feature.interface';
import { LauncherFeatureNameTypeEnum } from '../../../core/models/enums/launcher-feature-name-type.enum';
import { LauncherFeatureTooltipTypeEnum } from '../../../core/models/enums/launcher-feature-tooltip-type.enum';

@Component({
  selector: 'app-launcher-features',
  templateUrl: './launcher-features.component.html'
})
export class LauncherFeaturesComponent {
  @Input() launcherFeatures: ILauncherFeature[] = [];
  appConst = AppConstants;

  public getFeatureName(launcherFeature: ILauncherFeature): string {
    return LauncherFeatureNameTypeEnum[launcherFeature.FeatureKey];
  }

  public getFeatureTooltip(launcherFeature: ILauncherFeature): string {
    return LauncherFeatureTooltipTypeEnum[launcherFeature.FeatureKey];
  }
}
